import styled from 'styled-components'

const StyledWorkspaceContainer = styled.div`
  height: 100vh;
  width: 100vw;

  display: grid;
  grid-template-rows: 80px 1fr;
  grid-template-columns: 100px 1fr 320px;

  @media (max-width: 1024px) {
    grid-template-columns: 100px 1fr 300px;
  }

  @media (max-width: 768px) {
    grid-template-rows: 80px 80px auto 1fr;
    grid-template-columns: 100vw;
  }
`

const StyledWorkspaceHeader = styled.div`
  height: 80px;
  grid-row: 1;
  grid-column: 1 / 4;

  @media (max-width: 768px) {
    grid-column: 1;
  }
`

const StyledWorkspaceFloorList = styled.div`
  width: 100px;
  height: 100%;
  background-color: #282d41;
  grid-row: 2;
  grid-column: 1;

  @media (max-width: 768px) {
    width: 100%;
    height: 80px;
  }
`

const StyledWorkspaceFilter = styled.div`
  grid-row: 2;
  grid-column: 3;

  @media (max-width: 768px) {
    grid-row: 3;
    grid-column: 1;
  }
`

const StyledWorkspaceFloorPlan = styled.div`
  background-color: #eff0f3;
  height: 100%;
  grid-row: 2;
  grid-column: 2;
  display: ${props => (props.showBuildingList ? 'none;' : 'block;')} @media
    (max-width: 768px) {
    grid-row: 4;
    grid-column: 1;
  }

  @media (max-width: 420px) {
    padding-bottom: 60px;
  }
`

const StyledWorkspaceActionButton = styled.div`
  position: absolute;
  top: auto;
  left: auto;
  right: 348px;
  bottom: 30px;

  @media (max-width: 1024px) {
    top: auto;
    left: auto;
    right: 324px;
    bottom: 26px;
  }

  @media (max-width: 768px) {
    top: 271px;
    left: auto;
    right: 30px;
    bottom: auto;
  }

  @media (max-width: 420px) {
    position: absolute;
    top: auto;
    left: auto;
    right: 20px;
    bottom: 24px;
  }
`
export {
  StyledWorkspaceContainer,
  StyledWorkspaceHeader,
  StyledWorkspaceFloorList,
  StyledWorkspaceFilter,
  StyledWorkspaceFloorPlan,
  StyledWorkspaceActionButton
}
